<form [formGroup]="sellingPriceHistoryForm" (ngSubmit)="submit()">
  <div class="row gy-2">
    <div class="col-12 col-md-3">
      <label class="form-label">Effective Date</label>
      <p-datepicker
        showIcon
        styleClass="w-100"
        formControlName="effectiveDate"
        [dateFormat]="'yy-mm-dd'"
        placeholder="Select Effective Date"
      >
      </p-datepicker>
    </div>
    <div class="col-12 col-md-3">
      <label class="form-label">Quantity <span class="text-danger">*</span></label>
      <input type="number" class="form-control" placeholder="Enter" min="0" formControlName="quantity" />
      <!-- @if (form.get('quantity')?.touched && form.get('quantity')?.hasError('required')) {
            <small class="text-danger">Quantity is required</small>
          } @else if (form.get('quantity')?.touched && form.get('quantity')?.hasError('min')) {
            <small class="text-danger">Quantity cannot be negative</small>
          } -->
    </div>
    <div class="col-12 col-md-3">
      <currency-input-field
        [label]="'Unit Price'"
        [placeholder]="'Enter'"
        [requiredLabel]="true"
        formControlName="unitPrice"
        [min]="0"
        [currencySymbol]="currencySymbol()"
      ></currency-input-field>
      <!-- @if (form.get('unitPrice')?.touched && form.get('unitPrice')?.hasError('required')) {
            <small class="text-danger">Unit Price is required</small>
          } @else if (form.get('unitPrice')?.touched && form.get('unitPrice')?.hasError('min')) {
            <small class="text-danger">Unit Price cannot be negative</small>
          } -->
    </div>
    <div class="col-12 col-md-3 align-self-center">
      <label class="form-label">Amount</label>
      <div class="text-success fw-600 fs-20">
        {{ totalAmount() | currency: currencySymbol() ?? undefined : 'symbol' }}
      </div>
    </div>

    <div class="col-12 col-md-3">
      <currency-input-field
        [label]="'Retail Credit'"
        [placeholder]="'Enter'"
        formControlName="retailCredit"
        [min]="0"
        [currencySymbol]="currencySymbol()"
      ></currency-input-field>
      <!-- @if (form.get('retailCredit')?.touched && form.get('retailCredit')?.hasError('min')) {
            <small class="text-danger">Retail Credit cannot be negative</small>
          } -->
    </div>

    <div class="col-auto align-self-end ms-auto">
      <div class="d-flex align-items-center gap-2">
        <button class="btn btn-outline-secondary btn-h42" (click)="onCancel()">Cancel</button>
        <button class="btn btn-primary btn-h42" type="submit">Save</button>
      </div>
    </div>
  </div>
</form>
